export const prop = [
    {
        id:1,
        title:'Commercial',
        cost:'1200',
        l1:'Office space',
        l2:'Shopping center',
        l3:'Stores',
        l4:'Parking faculties',
         l5:'Customer square',
    },
    {
        id:2,
        title:'Industrial',
        cost:'1800',
        l1:'Office space',
        l2:'Manufacturing space',
        l3:'Stores',
        l4:'Waste area',
         l5:'Enquiry desk',
    },
    {
        id:3,
        title:'Agricultual',
        cost:'2500',
        l1:'Office space',
        l2:'Stores',
        l3:'Processing machines',
        l4:'Waste area',
        l5:'Weight measuring room'
    }
];